import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import PersonalInfo from "./PersonalInfo";
import ExperienceAndLocation from "./ExperienceAndLocation";
import PersonalPhoto from "./PersonalPhoto";
import PersonalContact from "./PersonalContact";
import PersonalDescription from "./PersonalDescription";

import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import { storage } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";


import "./style.css";

export default function ProfileFillingPage() {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const userRef = firestore.collection("usersData").doc(user.uid);

  const [userPersonal, setUserPersonal] = useState({});
  const [userExperience, setUserExperience] = useState({});
  const [imageAsFile, setImageAsFile] = useState("");
  const [userImageDownloadUrl, setUserImageDownloadUrl] = useState("");
  var userImageDownloadUrlTemp = "";
  const [userContact, setUserContact] = useState({});
  const [userDescription, setUserDescription] = useState({});
  React.useEffect(() => {
    userRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
          setUserPersonal(data.userPersonal || {});
          setUserExperience(data.userExperience || {});
          setUserImageDownloadUrl(data.userImageDownloadUrl || "");
          setUserContact(data.userContact || {});
          setUserDescription(data.userDescription || {});
        } else {
          // doc.data() will be undefined in this case
          setUserData("no such doc");
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);

  if (!user.emailVerified)
    return <div>אנא הפעל את חשבונך במייל שנשלח אליך.</div>;
  if (!userData) return <div>Loading Data</div>;
 

  const handleSubmit = async () => {
    //image handling
    if (imageAsFile) {
      const mainImage = storage.ref(`usersImages`).child(imageAsFile.name);
      await mainImage.put(imageAsFile);
      userImageDownloadUrlTemp = await mainImage.getDownloadURL();
      setUserImageDownloadUrl(userImageDownloadUrlTemp);
    }
    var userImageToSave = userImageDownloadUrlTemp
      ? userImageDownloadUrlTemp
      : userImageDownloadUrl;
    try {
      await userRef.set(
        {
          userPersonal,
          userExperience,
          userImageDownloadUrl: userImageToSave,
          userContact,
          userDescription,
        },
        { merge: true }
      );
    } catch (error) {
      console.error("Error creating user document", error);
    }
    window.location = "/Profile"
  };

  const sections = [
    { title: "פרופיל", url: "/Profile"},
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "/SearchLead" },
  ];

  return (
    <div>
    <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} navBarDisconnect = {true}/>
      </Container>
      <hr />
      <div className="update-page-wrapper">
      <h1 style={{ direction: "rtl", textAlign: "center" }}>
        ברוכים הבאים {userData.userFullName}, באפשרותך למלא או לעדכן פרטיך.
      </h1>
      <hr />
      <PersonalInfo
        userFullName={userData.userFullName}
        userPersonal={userPersonal || {}}
        setUserPersonal={setUserPersonal}
      />
      <hr />
      <ExperienceAndLocation
        userExperience={userExperience || {}}
        setUserExperience={setUserExperience}
      />
      <hr />
      <PersonalPhoto setImageAsFile={setImageAsFile} />
      <img className="profile-page-image" src={userImageDownloadUrl} alt='Profile img'/>
      <hr />
      <PersonalContact
        userEmail={userData.userEmail}
        userContact={userContact || {}}
        setUserContact={setUserContact}
      />
      <hr />
      <PersonalDescription
        userDescription={userDescription}
        setUserDescription={setUserDescription}
      />
      {/* {console.log(userDescription)} */}
      <hr />
      <Button onClick={handleSubmit} variant="success">
         שמור שינויים וסיים
      </Button>{" "}
    </div>
    </div>
  );
}
